import { copyTextToClipboard } from '../../../common/utils/copy-text-to-clipboard';
export function share({ url, isMobile, afterCopy, }) {
    const clipboardFlow = () => {
        copyTextToClipboard(url);
        afterCopy();
    };
    if (isMobile) {
        openNativeShareIfSupported({ url }, clipboardFlow);
    }
    else {
        clipboardFlow();
    }
}
function openNativeShareIfSupported({ url }, fallback) {
    if (typeof navigator !== 'undefined' && navigator.share) {
        navigator.share({ url });
    }
    else {
        fallback();
    }
}
//# sourceMappingURL=share.js.map